import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { Key, useEffect, useState } from "react";
import { ICustomerAccountSummary } from "../../../AccountTypes";
import { accountService } from "../../../AccountService";
import useNavModel from "../../../../../model/navModel";
import { ITreeData } from "../../../../base/dict/dictModel";
import { OptionDsType } from "../../../../../types/FmsTypes";
import { useGlobalModel } from "@/model/globalModel";
import { IMdOrgDetail } from "@/views/base/org/orgService";
import { IMdDictFields } from "@/views/base/dict/dictService";

export enum ActionTypeEnum {
    ACCOUNT,
    ADJUST_LIST,
    RECHARGE_LIST,
    TRANSFER_LIst,
    BILL_LIST,
    WRITEOFF_LIST,
    LOG_LIST
}

type labelsType = {
    [proppName: string]: string;
}

export const useDetailModel = createModel(function () {
    const { user: { shopCode } } = useGlobalModel();
    const [customerCode, setCustomerCode] = useSessionStorageState<string>("account.detail.customerCode", "");
    const [actionType, setActionType] = useState<ActionTypeEnum>(ActionTypeEnum.ACCOUNT) // 选中展示模块
    const [customer, setCustomer] = useState<ICustomerAccountSummary>({ key: "" });
    const { closeNav } = useNavModel(() => []);

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [beDs, setBeDs] = useState<OptionDsType[]>();
    const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});
    const [payMethodDs, setPayMethodDs] = useState<ITreeData<IMdDictFields>[]>();




    const loadSummaryData = (code?: Key) => {
        if (customerCode) {
            accountService
                .customerSummaryOne(customerCode, shopCode)
                .then(({ retData }) => {
                    setCustomer(retData);
                });
        }
    }

    return {
        orgDs,
        beDs,
        payMethodDs,
        payMethodLabels,
        actionType,
        customerCode,
        customer,
        setActionType,
        setCustomerCode,
        loadSummaryData,
        setOrgDs,
        setBeDs,
        setPayMethodDs,
        setPayMethodLabels,
        closeNav,
    }
});
